import Vue from 'vue';
import VueRouter from 'vue-router'
// import Index from "../index/Index.vue"
import Main from "../index/Main.vue"
import Login from "../login/Login.vue"

import urls from "../utils/urls"
import {post} from '../utils/http'

Vue.use(VueRouter)

const admin=[
    {
    meta: {
        title: '管理后台',
        requireAuth:true
    },
    name:"admin",
    path:"/admin",
    component:Main,
    children:[
        {
            meta: {
                title: '首页',
                requireAuth:true
            },
            name:"index",
            path:"index",
            // component:Index,
            component: resolve => require(['../index/Index.vue'], resolve)
        },

    ],
    redirect: "/admin/index"
},
    {
        meta: {
            title: '管理员登陆'
        },
        name:"admin_login",
        path:"/admin/login",
        component:Login
    },


]
const routes=[
  
    //单个路由均为对象类型，path代表的是路径，component代表组件
     ...admin,

]

//实例化VueRouter并将routes添加进去
const router=new VueRouter({
    'mode':"history",
    //ES6简写，等于routes：routes
        routes
    });

router.onReady(() => {

    let router_list=JSON.parse(sessionStorage.getItem("router_list"))
    let components=[]
    for (let k in router_list){
        let component_name=router_list[k]['meta']['component_name']
        let item={
            meta:router_list[k]['meta'],
            name:router_list[k]['name'],
            path:router_list[k]['path'],
            component: () =>import(`@/components/${component_name}`)
        }
        components.push(item)
    }
    // console.log("read",admin)
    // console.log("read1",router.options.routes)
    admin[0]['children']=[...components]

    let arr_404=[ {
        meta: {
            title: '网页不存在'
        },
        path: "/404",
        name: "notFound",
        component: resolve => require(['../not_found/notFound'], resolve)
    },
        {
            path: "*", // 此处需特别注意置于最底部
            redirect: "/404"
        }]
    router.addRoutes([...admin,...arr_404])

})

router.beforeEach((to, from, next) => {

        document.title = to.meta.title
        const requireAuth=to.meta.requireAuth

        // alert(JSON.stringify(to))


        if(requireAuth){
          
          checkverify(next,from);
        }else{
            //getPermissionMenuAction


          next()
        }
       
      })   
    //抛出这个这个实例对象方便外部读取以及访问


    function checkverify(next,from){
      
      const user_data=localStorage.getItem("sh_admin_user_data")
      
      let json_data={}
      if(user_data!== null){
     
       json_data=JSON.parse(user_data)
      
       
      }
    
      
       post(urls.admin.login.getVerify,json_data).then((result)=>{
        
         const data=result

          let route_list=JSON.parse(sessionStorage.getItem("router_list"))
          //
          //  if(route_list!=null){
          //    router.addRoutes([...route_list])
          //
          //  }
           if(data.code==200){

            if(route_list==null){
                get_menu()

            }


             next()



         }else{
           console.log(from.fullPath)
           router.push({path:"/admin/login"})
           // next({
           //   name: 'user_login',
           //   query: {redirect: to.fullPath}
           //   })
         }
      
       
      
          
       });
     
     
     }
     var route_list=[]
     var route_list_bak=[]
     function get_menu(){

        post(urls.admin.menu.permission,{}).then((value)=>{
           let val=value.data

            if(value.code==404){
                localStorage.removeItem("sh_admin_user_data");
                sessionStorage.removeItem("router_list")
               router.push({
                    name: "admin_login",
                });
                return
            }
            for(let k in val){

                for(let kk in val[k]['children']){


                    let component= val[k]['children'][kk]["component"]
                    let item= {
                        meta:{
                            title: val[k]['children'][kk]["title"],
                            requireAuth: val[k]['children'][kk]["requireAuth"],
                            component_name:`${component}`
                        },
                        name: val[k]['children'][kk]["name"],
                        path: val[k]['children'][kk]["path"],

                        // component:resolve => require([`${val[k]['children'][kk]["component"]}`],resolve)
                        component: () =>import(`@/components/${component}`)


                    }

                    let item1= {
                        meta:{
                            title: val[k]['children'][kk]["title"],
                            requireAuth: val[k]['children'][kk]["requireAuth"],
                            component_name:`${component}`
                        },
                        name: val[k]['children'][kk]["name"],
                        path: val[k]['children'][kk]["path"],


                    }
                    route_list.push(item)
                    route_list_bak.push(item1)
                    // router.options.routes[0]["children"].push(item)


                }


            }

            admin[0].children=[...route_list]
            // sessionStorage.removeItem("router_list")

            sessionStorage.setItem("router_list",JSON.stringify(route_list_bak))

            router.addRoutes([...admin])
            console.log("新",router.options.routes)
        })


}
    export default router